"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWeeks = exports.useDaysSelected = exports.useCurrentTime = void 0;

var _react = require("react");

var _Helpers = require("./Helpers");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var normalizeTime = function normalizeTime(date) {
  return (0, _Helpers.setDate)(date, {
    hours: 12,
    milliseconds: 0,
    minutes: 0,
    seconds: 0
  });
};
/**
 * Handles selected days and stabilize date time when set to avoid problems
 * when the range is used to check intervals.
 */


var useDaysSelected = function useDaysSelected(initialMonth) {
  var _useState = (0, _react.useState)(function () {
    var date = normalizeTime(initialMonth);
    return [date, date];
  }),
      _useState2 = _slicedToArray(_useState, 2),
      daysSelected = _useState2[0],
      set = _useState2[1];

  var setDaysSelected = (0, _react.useCallback)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        start = _ref2[0],
        end = _ref2[1];

    // Preserves the reference of dates
    if (start === end) {
      var date = normalizeTime(start);
      set([date, date]);
    } else {
      set([normalizeTime(start), normalizeTime(end)]);
    }
  }, []);
  return [daysSelected, setDaysSelected];
};
/**
 * Generates the table of days of the month.
 */


exports.useDaysSelected = useDaysSelected;

var useWeeks = function useWeeks(currentMonth, firstDayOfWeek) {
  var _useState3 = (0, _react.useState)(function () {
    return getWeekArray(currentMonth, firstDayOfWeek);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      weeks = _useState4[0],
      set = _useState4[1];

  var setWeeks = (0, _react.useCallback)(function (value) {
    return set(getWeekArray(value, firstDayOfWeek));
  }, [firstDayOfWeek]);
  return [weeks, setWeeks];
};
/**
 * Sets the current time
 */


exports.useWeeks = useWeeks;

var useCurrentTime = function useCurrentTime(use12Hours) {
  var _useState5 = (0, _react.useState)('--:--'),
      _useState6 = _slicedToArray(_useState5, 2),
      currentTime = _useState6[0],
      set = _useState6[1];

  var setCurrentTime = (0, _react.useCallback)(function (hours, minutes, ampm) {
    var date = (0, _Helpers.setDate)(new Date(), {
      hours: hours,
      minutes: minutes
    });

    if (typeof hours !== 'string') {
      hours = (0, _Helpers.formatDate)(date, 'HH');

      if (use12Hours) {
        hours = (0, _Helpers.formatDate)((0, _Helpers.setDate)(new Date(), {
          hours: hours
        }), 'hh');
      }
    }

    if (typeof minutes !== 'string') {
      minutes = (0, _Helpers.formatDate)(date, 'mm');
    }

    var value = ampm ? "".concat(hours, ":").concat(minutes, " ").concat(ampm) : "".concat(hours, ":").concat(minutes);
    set(value);
    return value;
  }, []);
  return [currentTime, setCurrentTime];
};

exports.useCurrentTime = useCurrentTime;

function getDaysInMonth(d) {
  var firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1, 12);
  firstDayOfMonth.setMonth(firstDayOfMonth.getMonth() + 1);
  firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1);
  return firstDayOfMonth.getDate();
}
/**
 * Utility function to generate a table two days of the month.
 * Based on (This implementation does not have the fixation of
 * 6 weeks) https://github.com/gpbl/react-day-picker/blob/master/src/Helpers.js#L55
 *
 * @example
 * getWeekArray(new Date(), 0);
 *
 * [
 *   [
 *     {
 *       date: Sun Dec 30 2018 12:00:00 GMT-0300...
 *       nextMonth: false
 *       previousMonth: true
 * 	   },
 *     ...
 *   ]
 *   ...
 * ]
 *
 * The `outside` property references when a day
 * does not belong to the current month.
 */


function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];
  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    var genDay = new Date(d.getFullYear(), d.getMonth(), i, 12);
    dayArray.push({
      date: genDay
    });
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.date.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }

    week.push(day);

    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  }); // unshift days from start of the first week

  var firstWeek = weekArray[0];

  for (var _i2 = 7 - firstWeek.length; _i2 > 0; _i2 -= 1) {
    var outsideDate = (0, _Helpers.clone)(firstWeek[0].date);
    outsideDate.setDate(firstWeek[0].date.getDate() - 1);
    firstWeek.unshift({
      date: outsideDate,
      previousMonth: true
    });
  } // push days until the end of the last week


  var lastWeek = weekArray[weekArray.length - 1];

  for (var _i3 = lastWeek.length; _i3 < 7; _i3 += 1) {
    var _outsideDate = (0, _Helpers.clone)(lastWeek[lastWeek.length - 1].date);

    _outsideDate.setDate(lastWeek[lastWeek.length - 1].date.getDate() + 1);

    lastWeek.push({
      date: _outsideDate,
      nextMonth: true
    });
  }

  return weekArray;
}